export default __webpack_public_path__ + "static/media/en.f9ded3a7.svg";